import { takeEvery, fork, put, all, call } from 'redux-saga/effects';
import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { CUSTOMER_SESSION, CUSTOMER_SESSION_SUCCESS, CUSTOMER_SESSION_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getCustomerSession({ payload }) {
  const filteredHeaders = { ...customHeaders };
  delete filteredHeaders['X-Requested-By'];

  const ticketId = payload?.data?.ticketId;

  const result = yield call(apiCall, {
    url: `${adminAPIURL}/v2/admin/customer-sessions/${ticketId}`,
    method: 'GET',
    headers: { ...filteredHeaders },
    params: payload?.urlParams,
  });

  // result is either axios response OR axios error (because apiCall returns err)
  const statusCode = result?.status ?? result?.response?.status ?? null;
  const data = result?.data ?? result?.response?.data ?? null;
  const message = data?.message ?? result?.message ?? null;

  if (statusCode === 200) {
    yield put({ type: CUSTOMER_SESSION_SUCCESS, payload: data });
    return;
  }

  yield put({
    type: CUSTOMER_SESSION_ERROR,
    payload: { statusCode, message },
  });
}

export function* watchCustomerSession() {
  yield takeEvery(CUSTOMER_SESSION, getCustomerSession);
}

export default function* watchCustomerSessionSaga() {
  yield all([fork(watchCustomerSession)]);
}
